import service from '../base'
export default {
  list(options) {
    return service.post('/mainapi/record/recordDiagnose/list', options)
  }
}
